module.exports = __webpack_public_path__ + "static/img/9.79a034c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/eng/9.png
// module id = LiwG
// module chunks = 0